export enum ETableType {
  PERIOD = 'PERIOD',
  DAILY = 'DAILY',
}
